/**
 * The Client Identity override — a foot-gun behind a disclosure.
 *
 * ADR-0015 records why this exists and why it is presented like this. The
 * portal identifies itself honestly by default (D19), with a product name and a
 * monitored contact address, and that is what almost every profile should keep.
 * But a publisher's CDN can allowlist a short list of client identities and
 * refuse every other one — including an honest one — on an endpoint that needs
 * no account at all. Where that happens the operator needs a way through that
 * is not "give up on this source".
 *
 * So it is collapsed, blank, and labelled as an escape hatch. The thing that
 * sends anyone here is the failure hint on `source_refused_client`, which names
 * this control. That is a UI convention rather than an enforced one: nothing
 * stops a profile being given a browser `User-Agent`, and nothing here tries to
 * — the ADR is explicit that the honesty is a norm the portal encourages rather
 * than a rule it imposes.
 */

import { Field, TextInput } from "./ui";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function ClientIdentityField({ value, onChange }: Props) {
  return (
    <details className="rounded-lg border border-line px-md py-sm">
      <summary className="cursor-pointer text-body-sm text-muted">
        Client identity (advanced)
      </summary>
      <div className="mt-sm">
        <Field
          label="User-Agent"
          hint="Leave blank unless a publisher refuses the portal. Some CDNs allow only a short list of client identities and refuse every other one — including an honest one — on endpoints that need no account. A refusal will say so and send you here."
        >
          <TextInput
            value={value}
            placeholder="Blank — identify as this portal"
            onChange={(event) => onChange(event.target.value)}
          />
        </Field>
      </div>
    </details>
  );
}
